export default __webpack_public_path__ + "7c51ad7.png";